export const OPERATOR_STATUS_LABEL = 'Operator status';
export const OPERATOR_STATUS_SHORT_LABEL = 'Operator';
export const OPERATOR_STATUS_SOURCE = 'NM OCD operator search registry';
export const OPERATOR_STATUS_ACTIVE_TOOLTIP = 'Active in OCD export. Not live field activity.';
export const OPERATOR_STATUS_COMPANION_LINE = 'Official OCD operator registry/status summary. "Active" means the operator appears in the OCD export with inactive operators excluded; it does not indicate live field activity or current operations.';

export const OPERATOR_STATUS_ADMIN_DIAGNOSTIC_LINE = 'Geometry: none. Formal compliance finding: no. Live field activity: no.';
